var $d0f488d433b55b8a$exports = {};
$d0f488d433b55b8a$exports = {
  "dragDescriptionKeyboard": "\u6309 Enter \u5F00\u59CB\u62D6\u52A8\u3002",
  "dragDescriptionKeyboardAlt": "\u6309 Alt + Enter \u5F00\u59CB\u62D6\u52A8\u3002",
  "dragDescriptionLongPress": "\u957F\u6309\u4EE5\u5F00\u59CB\u62D6\u52A8\u3002",
  "dragDescriptionTouch": "\u53CC\u51FB\u5F00\u59CB\u62D6\u52A8\u3002",
  "dragDescriptionVirtual": "\u5355\u51FB\u5F00\u59CB\u62D6\u52A8\u3002",
  "dragItem": function dragItem(args) {
    return "\u62D6\u52A8 ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "\u62D6\u52A8 ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u9009\u4E2D\u9879\u76EE");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u9009\u4E2D\u9879\u76EE");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "\u6309 Enter \u4EE5\u62D6\u52A8 ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879");
      }
    }), "\u3002");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "\u6309 Alt + Enter \u4EE5\u62D6\u52A8 ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879");
      }
    }), "\u3002");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "\u957F\u6309\u4EE5\u62D6\u52A8 ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879");
      }
    }), "\u3002");
  },
  "dragStartedKeyboard": "\u5DF2\u5F00\u59CB\u62D6\u52A8\u3002\u6309 Tab \u5BFC\u822A\u5230\u653E\u7F6E\u76EE\u6807\uFF0C\u7136\u540E\u6309 Enter \u653E\u7F6E\u6216\u6309 Escape \u53D6\u6D88\u3002",
  "dragStartedTouch": "\u5DF2\u5F00\u59CB\u62D6\u52A8\u3002\u5BFC\u822A\u5230\u653E\u7F6E\u76EE\u6807\uFF0C\u7136\u540E\u53CC\u51FB\u653E\u7F6E\u3002",
  "dragStartedVirtual": "\u5DF2\u5F00\u59CB\u62D6\u52A8\u3002\u5BFC\u822A\u5230\u653E\u7F6E\u76EE\u6807\uFF0C\u7136\u540E\u5355\u51FB\u6216\u6309 Enter \u653E\u7F6E\u3002",
  "dropCanceled": "\u653E\u7F6E\u5DF2\u53D6\u6D88\u3002",
  "dropComplete": "\u653E\u7F6E\u5DF2\u5B8C\u6210\u3002",
  "dropDescriptionKeyboard": "\u6309 Enter \u653E\u7F6E\u3002\u6309 Escape \u53D6\u6D88\u62D6\u52A8\u3002",
  "dropDescriptionTouch": "\u53CC\u51FB\u653E\u7F6E\u3002",
  "dropDescriptionVirtual": "\u5355\u51FB\u653E\u7F6E\u3002",
  "dropIndicator": "\u653E\u7F6E\u6807\u8BB0",
  "dropOnItem": function dropOnItem(args) {
    return "\u653E\u7F6E\u4E8E ".concat(args.itemText);
  },
  "dropOnRoot": "\u653E\u7F6E\u4E8E",
  "endDragKeyboard": "\u6B63\u5728\u62D6\u52A8\u3002\u6309 Enter \u53D6\u6D88\u62D6\u52A8\u3002",
  "endDragTouch": "\u6B63\u5728\u62D6\u52A8\u3002\u53CC\u51FB\u53D6\u6D88\u62D6\u52A8\u3002",
  "endDragVirtual": "\u6B63\u5728\u62D6\u52A8\u3002\u5355\u51FB\u53D6\u6D88\u62D6\u52A8\u3002",
  "insertAfter": function insertAfter(args) {
    return "\u63D2\u5165\u5230 ".concat(args.itemText, " \u4E4B\u540E");
  },
  "insertBefore": function insertBefore(args) {
    return "\u63D2\u5165\u5230 ".concat(args.itemText, " \u4E4B\u524D");
  },
  "insertBetween": function insertBetween(args) {
    return "\u63D2\u5165\u5230 ".concat(args.beforeItemText, " \u548C ").concat(args.afterItemText, " \u4E4B\u95F4");
  }
};
export { $d0f488d433b55b8a$exports as default };